import { Content } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { TitlePage } from "@components/commun";
import { Text } from "@components/ui";
import { ETitleLineStyles } from "@middleware/types";
import style from "./OurBeliefs.module.scss";
/**
 * Props for `OurBeliefs`.
 */
export type OurBeliefsProps = SliceComponentProps<Content.OurBeliefsSlice>;

/**
 * Component for "OurBeliefs" Slices.
 */
const OurBeliefs = ({ slice }: OurBeliefsProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={style.wrapper}
    >
      <div className="lk-wrap">
        <div className="lk-container">
          <TitlePage
            className={style.title}
            underline={ETitleLineStyles.STYLE_5}
          >
            <PrismicRichText field={slice.primary.title} />
          </TitlePage>
          <Text className={style.text}>
            <PrismicRichText field={slice.primary.text} />
          </Text>
        </div>
      </div>
    </section>
  );
};

export default OurBeliefs;
